import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  padding: 10px 0;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const Icon = styled.img`
  margin-right: 3px;
`;

const selectedStyle = css`
  border-color: #D32F2F;
  background-color: #FFF5F5;
  box-shadow: 0 2px 8px rgba(211, 47, 47, 0.1);
`;

export const Card = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px;
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  position: relative;

  ${({ $isSelected }) => $isSelected && selectedStyle}

  &:hover {
    transform: translateY(-1px); // Movimento mais curto
    border-color: ${({ $isSelected }) => ($isSelected ? '#B71C1C' : '#9E9E9E')};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h3`
  font-size: 15px;
  color: #333;
  margin: 0;
  line-height: 1.2;
`;

export const Subtitle = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #555;
  line-height: 1.3;
`;

export const DetailText = styled.span`
  font-size: 12px;
  color: #888;
  margin-top: 2px;
`;

export const RadioIndicator = styled.div`
  width: 18px; // Reduzido de 24px
  height: 18px; // Reduzido de 24px
  border-radius: 50%;
  border: 2px solid ${({ $isSelected }) => ($isSelected ? '#D32F2F' : '#9E9E9E')}; // Cor inativa mais suave
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 12px; // Aproximou o indicador do texto
  transition: all 0.2s;

  &::after {
    content: '';
    width: 8px; // Reduzido proporcionalmente
    height: 8px;
    border-radius: 50%;
    background-color: #D32F2F;
    transform: scale(${({ $isSelected }) => ($isSelected ? 1 : 0)});
    transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
`;